import swal from 'sweetalert2';
import { DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import { Switch as LSwitch } from '@/components/index';
import store from '@/services/store.js';
import { EventBus } from '@/services/Event.js';
import { VueEditor } from 'vue2-editor'

const svc = new ResourceSvc();

export default {
    props: ['courseId'],
    name: 'AdminDetailsTab',
    components: {
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Tag.name]: Tag,
        [Input.name]: Input,
        [Select.name]: Select,
        [Option.name]: Option,
        Button,
        LSwitch,
        VueEditor
    },
    data() {
        return {
            modelValidations: {
                subject: {
                    required: true,
                    min: 5
                },
                content: {
                    required: true,
                    min: 5
                }
            },
            customToolbar: [
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                ['bold', 'italic', 'underline', 'strike', 'link'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'color': [] }, { 'background': [] }],
                ['clean']
            ],
            isFreeForMembers: true,
            isFreeForNonMembers: true,
            isRegistrationForMembersAllowed: false,
            isRegistrationForNonMembersAllowed: false,
            isLoading: true,
            activeTypes: [],
            statuses: [],
            answerTypes: [],
            refundPolicyLog: [],
            general: {
                id: -1,
                name: '',
                town: '',
                county: '',
                url: '',
                status: 1,
                type: 1,
                durationInHours: 0,
                startDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
                endDate: new Date(new Date().getTime() + 100 * 60 * 60 * 1000),
                types: [],
                statuses: [],
                startDatePicker: null,
                refundPolicy: '',
                contactPersonName: '',
                contactPersonEmail: ''
            },
            pricing: {
                priceMembers: 0,
                priceNonMembers: 0,
                maxCountAttendants: 0,
                currentCountAttendants: 0,
                maxTickets: 1,
                maxTicketsLimitation: false
            },
            application: { questions: [], dateStartApplication: new Date(), dateEndApplication: new Date() },
            custom: {
                currentOptions: [], questions: [], questionTypes: [], currentQuestionIndex: 0, currentQuestionType: 1, currentAnswerType: 1, currentQuestionId: 0, currentQuestionField: '', currentQuestionIsVisible: false, currentQuestionIsRequired: false
            },
            description: '',
            isCreateCustomQuestionMode: false,
            isEditCustomQuestionMode: false,
            pickerOptions: {
                disabledDate(date) {
                    return date < date.setDate(date.getDate() - 1);
                },
                shortcuts: [
                    {
                        text: 'Tomorrow', onClick(picker) { picker.$emit('pick', new Date(new Date().getTime() + 24 * 60 * 60 * 1000)); }
                    },
                    {
                        text: 'In one week',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 3600 * 1000 * 24 * 2 * 7);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: 'In two weeks',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 3600 * 1000 * 24 * 2 * 7);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: 'In one month',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: 'In three months',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3 * 30);
                            picker.$emit('pick', date);
                        }
                    }
                ]
            }
        };
    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName)
        },
        isSaveAllowed() {

            if (typeof this.general.id == 'string') {
                return;
            }

            var isAllowed = true;
            if (this.general.name.length < 1) {
                this.badRequestSwal("Name is required field!");
                isAllowed = false;
            }
            else if (this.general.name.length > 150) {
                this.badRequestSwal("Too long name of the event. Max is 150 characters.");
                isAllowed = false;
            }

            if (this.general.town.length > 100) {
                this.badRequestSwal("Too long town of the event. Max is 100 characters.");
                isAllowed = false;
            }

            if (this.general.durationInHours > 999) {
                this.badRequestSwal("Too long duration of the event. Max is 999.");
                isAllowed = false;
            }

            if (this.general.county.length > 100) {
                this.badRequestSwal("Too long county of the event. Max is 100 characters.");
                isAllowed = false;
            }

            if (this.general.url.length > 100) {
                this.badRequestSwal("Too long url of the event. Max is 100 characters.");
                isAllowed = false;
            }

            if (this.isRegistrationForMembersAllowed && !this.isFreeForMembers && (isNaN(this.pricing.priceMembers) || this.pricing.priceMembers < 1)) {
                this.badRequestSwal("Price for members is required. Please, uncheck box to do registrtion free or specify the value");
                isAllowed = false;
            }

            if (this.isRegistrationForNonMembersAllowed && !this.isFreeForNonMembers && (isNaN(this.pricing.priceNonMembers) || this.pricing.priceNonMembers < 1)) {
                this.badRequestSwal("Price for non members is required. Please, uncheck box to do registrtion free or specify the value");
                isAllowed = false;
            }

            if (this.general.startDate == null) {
                this.badRequestSwal("Date is required field and can't be empty");
                isAllowed = false;
            }

            if (this.general.endDate != null && this.general.endDate < this.general.startDate) {
                this.badRequestSwal("Date of end can't be before date of start");
                isAllowed = false;
            }

            if (this.application.dateEndApplication != null && this.application.dateStartApplication != null && this.application.dateEndApplication < this.application.dateStartApplication) {
                this.badRequestSwal("Date of end application can't be before date of start application");
                isAllowed = false;
            }

            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (this.general.contactPersonEmail && !re.test(String(this.general.contactPersonEmail).toLowerCase())) {
                this.badRequestSwal("Contact person email field has not valid value");
                isAllowed = false;
            }

            return isAllowed;
        },
        getQuestionType(id) {
            for (var i = 0; i < this.custom.questionTypes.length; i++) {
                if (this.custom.questionTypes[i].id == id) {
                    return this.custom.questionTypes[i].name;
                }
            }

            return 'Undefined';
        },
        removeQuestion(field) {
            var index = this.findQuestionIndexByField(field);

            if (index > -1) {
                this.custom.questions.splice(index, 1);
            }
        },
        saveQuestion() {
            if (this.custom.currentQuestionType == 3 && this.custom.currentOptions.length < 2) {
                this.badRequestSwal('You need to add at least 2 options!');
                return;
            }

            if (this.custom.currentQuestionField.length < 3 || this.custom.currentQuestionField.length > 150) {
                this.badRequestSwal('Question length should be at least 3 charaters and 150 characters maximum!');
                return;
            }

            if (this.isCreateCustomQuestionMode) {
                if (this.findQuestionIndexByField(this.custom.currentQuestionField)) {
                    this.badRequestSwal('You have already this question! Please use another one!');
                    return;
                }

                if (this.custom.currentQuestionType != 3) {
                    this.custom.currentOptions = [];
                } else {
                    if (this.custom.currentOptions[this.custom.currentOptions.length - 1].name == '') {
                        this.custom.currentOptions.splice(this.custom.currentOptions.length - 1, 1);
                    }
                }

                var newQuestion = {
                    currentQuestionIndex: this.custom.questions.length + 1,
                    id: this.custom.currentQuestionId,
                    field: this.custom.currentQuestionField,
                    hasOptions: this.custom.currentQuestionType == 3,
                    isRequired: this.custom.currentQuestionIsRequired,
                    isVisible: this.custom.currentQuestionIsVisible,
                    type: this.custom.currentQuestionType,
                    options: this.custom.currentOptions,
                    typeAnswer: this.custom.currentAnswerType

                };
                this.custom.questions.push(newQuestion);
                this.switchCreateCustomQuestionMode();
            }

            if (this.isEditCustomQuestionMode) {

                if (this.custom.currentQuestionType != 3) {
                    this.custom.currentOptions = [];
                } else {
                    if (this.custom.currentOptions[this.custom.currentOptions.length - 1].name == '') {
                        this.custom.currentOptions.splice(this.custom.currentOptions.length - 1, 1);
                    }
                }

                this.custom.questions[this.custom.currentQuestionIndex].field = this.custom.currentQuestionField;
                this.custom.questions[this.custom.currentQuestionIndex].hasOptions = this.custom.currentQuestionType == 3;
                this.custom.questions[this.custom.currentQuestionIndex].isRequired = this.custom.currentQuestionIsRequired;
                this.custom.questions[this.custom.currentQuestionIndex].isVisible = this.custom.currentQuestionIsVisible;
                this.custom.questions[this.custom.currentQuestionIndex].type = this.custom.currentQuestionType;
                this.custom.questions[this.custom.currentQuestionIndex].options = this.custom.currentOptions;
                this.custom.questions[this.custom.currentQuestionIndex].typeAnswer = this.custom.currentAnswerType;

                this.switchEditCustomQuestionMode('');
            }
        },
        saveAndAddEmptyOption() {
            var newOption = this.custom.currentOptions[this.custom.currentOptions.length - 1];
            if (/\S/.test(newOption.name) == false) {
                this.badRequestSwal('Name of the option can be empty or white space!');
                return;
            }
            if (this.custom.currentOptions.length > 1 && this.findOptionIndexByName(newOption.name) != this.custom.currentOptions.length - 1) {
                this.badRequestSwal('Name of the option already used for the another option. Please, change it to continue!');
                return;
            }
            if (newOption.name.length >= 100) {
                this.badRequestSwal('To long option. Max 100 characters!');
                return;
            }
            //add new
            this.custom.currentOptions.push({ id: 0, name: '', value: '' });
        },
        findQuestionIndexByField(field) {
            for (var i = 0; i < this.custom.questions.length; i++) {
                if (this.custom.questions[i].field == field) {
                    return i;
                }
            }
            return null;
        },
        findOptionIndexByName(name) {
            for (var i = 0; i < this.custom.currentOptions.length; i++) {
                if (this.custom.currentOptions[i].name == name) {
                    return i;
                }
            }
            return null;
        },
        removeOption(option) {
            var index = this.custom.currentOptions.indexOf(option);
            if (index > -1) {
                this.custom.currentOptions.splice(index, 1);
            }
        },
        switchCreateCustomQuestionMode() {
            this.custom.currentAnswerType = 1;
            this.custom.currentQuestionType = 1;
            this.custom.currentQuestionField = '';
            this.custom.currentQuestionId = 0;
            this.custom.currentQuestionHasOption = false;
            this.custom.currentQuestionIsVisible = true;
            this.custom.currentQuestionIsRequired = false;
            this.custom.currentOptions = [{ id: 0, name: '', value: '' }];

            this.isCreateCustomQuestionMode = !this.isCreateCustomQuestionMode;
        },
        switchEditCustomQuestionMode(field) {
            if (field != '') {
                var questionIndex = this.findQuestionIndexByField(field);
                var question = this.custom.questions[questionIndex];

                this.custom.currentAnswerType = question.typeAnswer;
                this.custom.currentQuestionType = question.type;
                this.custom.currentQuestionField = question.field;
                this.custom.currentQuestionId = question.id;
                this.custom.currentQuestionHasOption = question.hasOptions;
                this.custom.currentQuestionIsVisible = question.isVisible;
                this.custom.currentQuestionIsRequired = question.isRequired;
                this.custom.currentOptions = question.options;
                this.custom.currentQuestionIndex = questionIndex;
                if (this.custom.currentOptions.length == 0) {
                    this.custom.currentOptions = [{ id: 0, name: '', value: '' }];
                }
            }
            this.isEditCustomQuestionMode = !this.isEditCustomQuestionMode;
        },
        isQuestionChanged(question) {
            if (question.isRequired && !question.isVisible) {
                question.isRequired = false;
            }
        },
        isCurrentQuestionValid() {
            if (this.custom.currentQuestionIsRequired && !this.custom.currentQuestionIsVisible) {
                this.custom.currentQuestionIsRequired = false;
            }
        },
        setStartDate(value) {
            this.general.startDate = new Date(value);
        },
        setEndDate(value) {
            this.general.endDate = new Date(value);
        },
        showData() {
            console.log(this.pricing.maxCountAttendants);
        },
        loadData() {
            if (this.general.id === "0") {
                this.general.id = 0;
            }
            var self = this;
            svc.getCourseById(self.general.id).then(response => {
                var allData = response.body;
                if (!allData.isSuccess && !allData.currentUserId) {
                    self.redirectTo("/", 100);
                    return;
                }

                if (response.body != null) {

                    if (allData.activeTypes.length == 0) {
                        self.badRequestSwal("Please, create first at least one active course type, to be able to create new course. Redirecting to courses...")
                        self.redirectTo('/admin/courses', 3000);
                        return;
                    }

                    self.isLoading = false;
                    self.activeTypes = allData.activeTypes;
                    self.statuses = allData.statuses;
                    self.answerTypes = allData.questionAnswerTypes;
                    self.custom.questionTypes = allData.customQuestionsAvailableTypes;
                    self.application.questions = allData.applicationDetails.applicationFields;

                    if (self.general.id != 0) {

                        self.general.id = allData.generalDetails.id;
                        store.commit('setCourseId', self.general.id);
                        store.commit('setCourseLocation', {
                            id: self.general.id,
                            longtitude: allData.generalDetails.longtitude,
                            latitude: allData.generalDetails.latitude
                        });

                        store.commit('setCourseTown', allData.generalDetails.town)
                        store.commit('setCourseCounty', allData.generalDetails.county)

                        self.general.name = allData.generalDetails.name;
                        store.commit('setCourseName', self.general.name);

                        self.general.startDate = allData.generalDetails.dateStart ? new Date(allData.generalDetails.dateStart) : null;
                        self.general.endDate = allData.generalDetails.dateEnd ? new Date(allData.generalDetails.dateEnd) : null;

                        self.general.url = allData.generalDetails.url;
                        self.general.status = allData.generalDetails.status;
                        self.general.type = allData.generalDetails.type;
                        self.general.durationInHours = allData.generalDetails.durationInHours;
                        self.general.refundPolicy = allData.generalDetails.refundPolicy;
                        self.general.contactPersonName = allData.generalDetails.contactPersonName;
                        self.general.contactPersonEmail = allData.generalDetails.contactPersonEmail;

                        self.refundPolicyLog = allData.refundPolicyLog;

                        self.pricing.maxCountAttendants = allData.generalDetails.maxCountAttendants;
                        self.pricing.currentCountAttendants = allData.generalDetails.countAttendants;

                        self.pricing.priceNonMembers = allData.pricingDetails.priceNonMembers;
                        self.pricing.priceMembers = allData.pricingDetails.priceMembers;

                        self.pricing.maxTickets = allData.generalDetails.maxTickets;
                        self.pricing.maxTicketsLimitation = self.pricing.maxTickets > 0;

                        self.isRegistrationForNonMembersAllowed = self.pricing.priceNonMembers != null;
                        self.isFreeForNonMembers = !self.pricing.priceNonMembers

                        self.isRegistrationForMembersAllowed = self.pricing.priceMembers != null;
                        self.isFreeForMembers = !self.pricing.priceMembers;

                        self.description = allData.generalDetails.description;
                        self.custom.questions = allData.customQuestions;

                        self.application.dateStartApplication = allData.applicationDetails.dateStartApplication ? new Date(allData.applicationDetails.dateStartApplication) : null;
                        self.application.dateEndApplication = allData.applicationDetails.dateEndApplication ? new Date(allData.applicationDetails.dateEndApplication) : null;

                    } else {
                        self.general.type = self.activeTypes[0].id;
                    }
                }
                else {
                    self.badRequestSwal("Data is invalid. Redirecting to courses...")
                    self.redirectTo('/admin/courses', 3000);
                    return;
                }
            },
                response => {
                    self.badRequestSwal();
                    self.redirectTo('/admin/courses', 3000);
                });
        },
        saveData() {
            if (!this.isSaveAllowed()) {
                return;
            }

            var self = this;
            var location = store.getters.getCourseLocation;
            self.general.town = store.getters.getCourseTown;
            self.general.county = store.getters.getCourseCounty;

            var priceMembers = this.pricing.priceMembers;
            if (!self.isRegistrationForMembersAllowed) {
                priceMembers = null;
            }
            else
                if (self.isFreeForMembers) {
                    priceMembers = 0;
                }

            var priceNonMembers = this.pricing.priceNonMembers;
            if (!self.isRegistrationForNonMembersAllowed) {
                priceNonMembers = null;
            }
            else
                if (self.isFreeForNonMembers) {
                    priceNonMembers = 0;
                }

            var data = {
                generalDetails: {
                    id: this.general.id,
                    name: this.general.name,
                    county: this.general.county,
                    durationInHours: this.general.durationInHours,
                    type: this.general.type,
                    status: this.general.status,
                    town: this.general.town,
                    dateStart: this.format_date(this.general.startDate),
                    dateEnd: this.format_date(this.general.endDate),
                    description: this.description,
                    maxCountAttendants: this.pricing.maxCountAttendants,
                    url: this.general.url,
                    longtitude: location.longtitude,
                    latitude: location.latitude,
                    refundPolicy: this.general.refundPolicy,
                    contactPersonName: this.general.contactPersonName,
                    contactPersonEmail: this.general.contactPersonEmail,
                    maxTickets: this.pricing.maxTickets > 1 ? Math.floor(this.pricing.maxTickets) : null
                },
                pricingDetails: {
                    priceMembers: priceMembers,
                    priceNonMembers: priceNonMembers
                },
                applicationDetails: {
                    dateStartApplication: this.format_date(this.application.dateStartApplication),
                    dateEndApplication: this.format_date(this.application.dateEndApplication),
                    applicationFields: this.application.questions
                },
                customQuestions: this.custom.questions
            };
            svc.saveCourse(data).then(response => {
                if (self.general.id == 0) {
                    self.$notify({
                        message: "Success. Course added!",
                        type: 'success',
                    });
                    //self.successSwal("Success. Course added!");
                    self.general.id = response.body.recordId;
                    self.loadData();
                } else {
                    if (response.body.isSuccess) {
                        self.$notify({
                            message: "Success. Course updated!",
                            type: 'success',
                        });
                    }
                    else {
                        self.$notify({
                            message: response.body.message,
                            type: 'danger',
                        });
                    }
                    
                    //self.successSwal("Success. Course updated!");
                    self.loadData();
                }

            }, response => {
                self.badRequestSwal();
            });
        },
        format_date(d) {
            var day = d.getDate();
            if ((day + '').length == 1) {
                day = '0' + day;
            }

            var month = d.getMonth() + 1;
            if ((month + '').length == 1) {
                month = '0' + month;
            }

            var hours = d.getHours();
            if ((hours + '').length == 1) {
                hours = '0' + hours;
            }

            var minutes = d.getMinutes();
            if ((minutes + '').length == 1) {
                minutes = '0' + minutes;
            }

            var seconds = d.getSeconds();
            if ((seconds + '').length == 1) {
                seconds = '0' + seconds;
            }

            var pretty_date = [d.getFullYear(), month, day].join('-');
            var pretty_time = [hours, minutes, seconds].join(':');

            return pretty_date + 'T' + pretty_time + '.000Z';
        },
        redirectTo(url, timer) {
            var self = this;
            setTimeout(function () {
                self.$router.push({ path: url });
            }, timer, url);
        },
        badRequestSwal(message) {
            if (!message) {
                message = 'Something went wrong. Incorrect request!';
            }
            this.$notify({
                message: message,
                type: 'danger',
                //timeout: 10000000
            });
        },
        successSwal(message) {
            var self = this;
            swal({
                title: 'Do you want to stay on this page or get back to courses?',
                text: message,
                type: 'success',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-default',
                cancelButtonClass: 'btn btn-danger',
                confirmButtonText: 'Yes, go to courses!',
                cancelButtonText: 'Stay on this page!',
                buttonsStyling: false
            }).then(function (result) {
                if (result.value == true) {
                    self.$router.push({ path: "/admin/courses" });
                }
            });
        }
    },
    created() {
        if (isNaN(this.courseId) || this.courseId.length == 0) {
            this.redirectTo("/admin/courses", 1);
            return;
        }

        this.general.id = this.courseId;
        if (this.courseId == 0) {
            store.commit('setCourseLocation', { id: 0, longtitude: null, latitude: null });
        }
        this.loadData();
        self = this;
        EventBus.$on("admin_save_course", data => {
            if (self.isSaveAllowed())
                self.saveData();
        });

        EventBus.$on("admin_load_course", data => {
            self.loadData();
        });
    }
};






// WEBPACK FOOTER //
// ./src/components/admin/courses/course-details/details-tab/details-tab.js